import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7bbac892")

_pushScopeId("data-v-7bbac892")
const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "text-20px font-semibold text-black-lp-100" }
const _hoisted_3 = { class: "text-16px text-black-lp-100" }
const _hoisted_4 = { class: "list-decimal space-y-3 pl-4" }
const _hoisted_5 = {
  class: "underline text-blue-lp-300",
  href: "https://www.google.com/maps",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_6 = { class: "text-gray-lp-800" }
const _hoisted_7 = { class: "mt-3 w-full" }
const _hoisted_8 = {
  start: "4",
  class: "list-decimal pl-4 pt-3 text-16px text-black-lp-100"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    class: "pickup-geolocation-modal",
    onClose: _ctx.onClose,
    width: "pickup-address-modal-width",
    showFooter: false,
    isCustomTitle: true,
    titlePadding: "px-4 py-4",
    contentPadding: "px-4 py-4",
    marginHeader: "mb-0",
    "data-testid": "pickup-address-geolocation-guide-modal"
  }, {
    "custom-title": _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("button", {
          type: "button",
          class: "flex h-5 w-5 items-center justify-center",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
        }, [
          _createVNode(_component_Icons, {
            name: "arrow-up",
            class: "h-4 w-4 text-black-lp-100 transform  -rotate-90"
          })
        ]),
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    content: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("ol", _hoisted_4, [
          _createVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("pickupAddress.guide.openMapsPrefix")) + " ", 1),
            _createVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("pickupAddress.guide.googleMaps")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupAddress.guide.openMapsSuffix")), 1)
          ]),
          _createVNode("li", null, _toDisplayString(_ctx.$t("pickupAddress.guide.searchLocation")), 1),
          _createVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("pickupAddress.guide.copyCoordinates")) + " ", 1),
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("pickupAddress.guide.coordinatesExample")), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("img", {
          class: "h-auto w-full",
          src: require('@/app/ui/assets/images/maps-coordinate.webp'),
          alt: "maps-coordinate"
        }, null, 8, ["src"])
      ]),
      _createVNode("ol", _hoisted_8, [
        _createVNode("li", null, _toDisplayString(_ctx.$t("pickupAddress.guide.enterCoordinates")), 1)
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})